
export function Browser_Types_Event__Event_get_Value(this$) {
    return this$.target.value;
}

export function Browser_Types_Event__Event_get_Checked(this$) {
    return this$.target.checked;
}

